import { useEffect } from "react";
import { useMountEffect } from "primereact/hooks";
import { useNavigate } from "react-router";

import { useMessenger } from "@/packages/portal-messenger";
import { PathNamekRoutes } from "@/router";

import Messages from "../constants/PortalMessenger/messages";
import { useSessionMan } from "../hooks/useSessionMan.hook";

const Logout = () => {
  const { isConnectionEstablished, sendDataMessage } = useMessenger();
  const { endSession } = useSessionMan();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnectionEstablished) return;

    const { key, value } = Messages.requestLogout;

    sendDataMessage(key, value);
  }, [isConnectionEstablished, sendDataMessage]);

  useMountEffect(() => {
    endSession();
    navigate(`/${PathNamekRoutes.LOGIN}`);
    setTimeout(() => {
      window.location.reload();
    });
  });

  return <></>;
};

export default Logout;
